import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface IBroadcastEvent {
  key: any;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {
  private eventBus: Subject<IBroadcastEvent>;

  constructor() {
    this.eventBus = new Subject<IBroadcastEvent>();
  }

  broadcast(key: any, data?: any): void {
    this.eventBus.next({ key, data });
  }

  on<T>(key: any): Observable<T> {
    return this.eventBus.asObservable().pipe(
      filter((event: any) => event.key === key),
      map((event: any) => event.data as T)
    );
  }
}
